import { Link } from 'react-router-dom';
import type { ReactNode } from 'react';

interface ContentCardProps {
  title: string;
  description: string;
  icon: ReactNode;
  to: string;
  count?: number;
  singleton?: boolean;
  complete?: boolean;
}

export default function ContentCard({
  title,
  description,
  icon,
  to,
  count,
  singleton,
  complete,
}: ContentCardProps) {
  return (
    <Link to={to} className="content-card">
      <div className="content-card-icon">{icon}</div>
      <div className="content-card-body">
        <h3 className="content-card-title">{title}</h3>
        <p className="content-card-desc">{description}</p>
        {singleton ? (
          <span className={`content-card-status ${complete ? 'content-card-status--done' : 'content-card-status--empty'}`}>
            {complete ? (
              <>
                <svg width={10} height={10} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={3} strokeLinecap="round" strokeLinejoin="round"><polyline points="20 6 9 17 4 12"/></svg>
                Set up
              </>
            ) : 'Not set up'}
          </span>
        ) : count !== undefined && (
          <span className="content-card-count">
            {count === 0 ? 'No items yet' : `${count} ${count === 1 ? 'item' : 'items'}`}
          </span>
        )}
      </div>
      <svg className="content-card-arrow" width={16} height={16} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round">
        <polyline points="9 18 15 12 9 6" />
      </svg>
    </Link>
  );
}
